module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel04_1280_1280_ja-2acfaa4b7ac8756362948276d05c993c.jpg";